import type { ComponentChildren } from 'preact';

export function Panel({ title, actions, class: cls, children }: { title?: ComponentChildren; actions?: ComponentChildren; class?: string; children?: ComponentChildren }) {
  return (
    <section class={`panel${cls ? ` ${cls}` : ''}`}>
      {(title || actions) && (
        <header class="panel-head">
          {title && <h2 class="panel-title">{title}</h2>}
          {actions && <div class="panel-actions">{actions}</div>}
        </header>
      )}
      {children}
    </section>
  );
}
